// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTrash = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M9 3h6v2h5v2h-1v11a3 3 0 01-3 3H8a3 3 0 01-3-3V7H4V5h5zM7 7v11a1 1 0 001 1h8a1 1 0 001-1V7zm4 2v8H9V9zm4 0v8h-2V9z"
    />
  );
export default SvgIconTrash;
